import React from "react";
import ReactDOM from "react-dom/client";
import ReactApexChart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import Container from "../../../../constants/Container";

interface SeriesData {
    name: string;
    data: number[];
}

interface ChartState {
    series: SeriesData[];
    options: ApexOptions;
}

const PreviousComp: React.FC = () => {
    const [state] = React.useState<ChartState>({
        series: [
            {
                name: "Marine Sprite",
                data: [44, 55, 41, 37, 22, 43, 21],
            },
            {
                name: "Striking Calf",
                data: [53, 32, 33, 52, 13, 43, 32],
            },
            {
                name: "Tank Picture",
                data: [12, 17, 11, 9, 15, 11, 20],
            },
            {
                name: "Bucket Slope",
                data: [9, 7, 5, 8, 6, 9, 4],
            },
            {
                name: "Reborn Kid",
                data: [25, 12, 19, 32, 25, 24, 10],
            },
        ],
        options: {

            chart: {
                type: "bar",
                height: 350,
                stacked: true,
                toolbar: {
                    show: false, // 👈 hides the menu entirely
                },
            },
            plotOptions: {
                bar: {
                    horizontal: true,
                    dataLabels: {
                        total: {
                            enabled: true,
                            offsetX: 0,
                            style: {
                                fontSize: "13px",
                                fontWeight: 900,
                            },
                        },
                    },
                },
            },
            stroke: {
                width: 1,
                colors: ["#fff"],
            },
            //   title: {
            //     text: "Fiction Books Sales",
            //   },
            xaxis: {
                categories: [2008, 2009, 2010, 2011, 2012, 2013, 2014],
                labels: {
                    formatter: (val: string | number) => val + "K",
                },
            },
            yaxis: {
                title: {
                    text: undefined,
                },
            },
            tooltip: {
                y: {
                    formatter: (val: number) => val + "K",
                },
            },
            fill: {
                opacity: 1,
            },
            legend: {
                position: "top",
                horizontalAlign: "left",
                offsetX: 40,
            },
        },
    });

    return (
        <Container padding>
            <div id="chart">
                <ReactApexChart
                    options={state.options}
                    series={state.series}
                    type="bar"
                    height={350}
                />
            </div>
            <div id="html-dist"></div>
        </Container>
    );
};

export default PreviousComp;
